import { LucideIcon } from "lucide-react";

// Prompt Types
export type PromptType =
  | "stock-ticker-recap"
  | "top-movers"
  | "sector-spotlight"
  | "index-overview";

export type Period = "day" | "week" | "month" | "quarter";
export type Direction = "gainers" | "losers" | "both";

export type Sector =
  | "technology"
  | "healthcare"
  | "financials"
  | "consumer-discretionary"
  | "consumer-staples"
  | "energy"
  | "industrials"
  | "materials"
  | "utilities"
  | "real-estate"
  | "communication-services";

export type MarketIndex = "S&P 500" | "Nasdaq" | "Dow Jones" | "Russell 2000";

// Variable Definition for prompt templates
export interface VariableDefinition {
  name: string;
  type: "ticker" | "period" | "direction" | "sector" | "indices" | "count";
  label: string;
  required: boolean;
  options?: string[];
  default?: string | string[];
  placeholder?: string;
}

// Prompt Type Configuration
export interface PromptTypeConfig {
  id: PromptType;
  name: string;
  description: string;
  icon: LucideIcon;
  variables: VariableDefinition[];
  messageTemplate: string;
}

// Wizard State
export interface MarketRecapWizardState {
  currentStep: number;
  promptType: PromptType | null;
  variables: Record<string, string | string[]>;
  selectedTemplateId: string | null;
  selectedTemplateName: string | null;
  selectedTemplatePreview: string | null;
}

// Template Definition
export interface MarketRecapTemplate {
  id: string;
  name: string;
  theme: string;
  description: string;
  previewUrl?: string;
}

// Sector display names
export const SECTOR_DISPLAY_NAMES: Record<Sector, string> = {
  technology: "Technology",
  healthcare: "Healthcare",
  financials: "Financials",
  "consumer-discretionary": "Consumer Discretionary",
  "consumer-staples": "Consumer Staples",
  energy: "Energy",
  industrials: "Industrials",
  materials: "Materials",
  utilities: "Utilities",
  "real-estate": "Real Estate",
  "communication-services": "Communication Services",
};

// All sectors list
export const SECTORS: Sector[] = [
  "technology",
  "healthcare",
  "financials",
  "consumer-discretionary",
  "consumer-staples",
  "energy",
  "industrials",
  "materials",
  "utilities",
  "real-estate",
  "communication-services",
];

// All indices list
export const MARKET_INDICES: MarketIndex[] = [
  "S&P 500",
  "Nasdaq",
  "Dow Jones",
  "Russell 2000",
];
